import { PaxCheckChecklistResolutionStatus } from "../../api";

enum ChecklistResolutionStatus {
  ReadyToFly = "ready-to-fly",
  EntryNotAllowed = "entry-not-allowed",
  ActionRequired = "action-required",
  Unknown = "unknown",
  NotEligible = "not-eligible",
}

export function ChecklistResolutionStatusFromApi(
  status: PaxCheckChecklistResolutionStatus
): ChecklistResolutionStatus {
  switch (status) {
    case PaxCheckChecklistResolutionStatus.ACTION_REQUIRED:
      return ChecklistResolutionStatus.ActionRequired;
    case PaxCheckChecklistResolutionStatus.ENTRY_NOT_ALLOWED:
      return ChecklistResolutionStatus.EntryNotAllowed;
    case PaxCheckChecklistResolutionStatus.READY_TO_FLY:
      return ChecklistResolutionStatus.ReadyToFly;
    case PaxCheckChecklistResolutionStatus.UNKNOWN:
      return ChecklistResolutionStatus.Unknown;
    case PaxCheckChecklistResolutionStatus.NOT_ELIGIBLE:
      return ChecklistResolutionStatus.NotEligible;
  }
}

export default ChecklistResolutionStatus;
